import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot
} from '@angular/router';
import { Observable } from 'rxjs';
import { SINGLETON_INJECTABLE_TYPE } from '../../common/models/constants.model';
import { ProjectFilterLookupContainer } from '../../common-project/models/lookups/project-filter-lookup-container.model';
import { ProjectFilterService } from '../../common-project/services/project-filter.service';
import { SessionStorageService } from '../../core/services/sessionStorage.service';

@Injectable({
  providedIn: SINGLETON_INJECTABLE_TYPE
})
export class LookupsResolver {

  private readonly SESSION_STORAGE_LOOKUPS = 'lookups';

  constructor(protected filterService: ProjectFilterService, protected sessionStorage: SessionStorageService) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<ProjectFilterLookupContainer> {
    const observableValue = new Observable<ProjectFilterLookupContainer>((observer: any) => {
      const lookups = this.sessionStorage.getItem(this.SESSION_STORAGE_LOOKUPS) as any;
      if (lookups) {
        this.filterService.lookupsLoaded.next(lookups);
        observer.next(lookups);
      } else {
        this.filterService.getLookups().subscribe({
          next: (result: ProjectFilterLookupContainer) => {
            this.sessionStorage.setItem(this.SESSION_STORAGE_LOOKUPS, result);
            this.filterService.lookupsLoaded.next(result);
            observer.next(result);
          },
          error: (error: any) => {
            observer.error(error);
          }
        });
      }
    });
    return observableValue;
  }
}
